<script>import { melt } from "@melt-ui/svelte";
import { ctx } from "../ctx.js";
export let asChild = false;
const { group, id } = ctx.setGroup();
</script>

{#if asChild}
	<slot builder={$group(id)} />
{:else}
	{@const builder = $group(id)}
	<div {...builder} use:builder.action {...$$restProps}>
		<slot {builder} />
	</div>
{/if}
